<template>
  <div class="">
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">PROGRAM DETAILS</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <div class="pull-right">
                <v-btn :depressed="true" small color="error" @click="deleteProgram()" class="futuristic-btn">Delete ({{delete_count}})</v-btn>
                <v-btn :depressed="true" small :to="{name: 'EditProgram', params: {program_id: this.$route.params.program_id}}" class="futuristic-btn"> <i class="fa fa-pencil"></i> Edit</v-btn>
              </div>
              <h2 class="earth-color program-title">{{singleProgram.name.toUpperCase()}} </h2>
              <v-divider class="my-3"></v-divider>
              <v-layout row wrap class="program-details">
                <v-flex xs6>
                  <p>Created on:</p>
                  <p>Updated on:</p>
                  <p>Price:</p>
                  <p>Start Date:</p>
                  <p>End Date:</p>
                  <p>Max Applicants:</p>
                  <p>Created by:</p>
                </v-flex>
                <v-flex xs6>
                  <p><b>{{formated_date_time(singleProgram.created_at)}}</b></p>
                  <p><b>{{formated_date(singleProgram.updated_at)}}</b></p>
                  <p><b>{{singleProgram.currency_sign}} {{$roundOff(singleProgram.price)}}</b></p>
                  <p><b>{{formated_date(singleProgram.start_date)}}</b></p>
                  <p><b>{{formated_date(singleProgram.end_date)}}</b></p>
                  <p><b>{{singleProgram.max_applicants}}</b></p>
                  <p><b>{{singleProgram.user}}</b></p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <program-images></program-images>
      </v-flex>
    </v-layout>
    <v-container fluid>
      <v-card flat class="futuristic-card">
        <div class="card-header">
          <h1 class="earth-color">PROGRAM INFORMATION</h1>
          <div class="title-decoration"></div>
        </div>
        <v-tabs
          v-model="active"
          slider-color="#587e27"
          class="futuristic-tabs"
        >
          <v-tab key="pdfcontent" ripple v-if="singleProgram.program_pdf !== null" class="earth-color">
            <v-icon left>picture_as_pdf</v-icon> Uploaded PDF
          </v-tab>
          <v-tab key="enteredcontent" ripple class="earth-color">
            <v-icon left>description</v-icon> Content
          </v-tab>
          <v-tab key="contactcontent" ripple class="earth-color">
            <v-icon left>contacts</v-icon> Contact List
          </v-tab>
          <v-tab key="applicants" ripple class="earth-color">
            <v-icon left>people</v-icon> Applicants List
          </v-tab>
        
          <v-tab-item key="pdfcontent" v-if="singleProgram.program_pdf !== null">
            <v-card flat>
              <v-container>
                <v-layout row wrap>
                  <v-flex lg8 md8 sm12 xs12>
                    <pdf
                      :src="singleProgram.program_pdf"
                      @num-pages="pageCount = $event"
                      @page-loaded="currentPage = $event"
                      :page="page"
                      class="futuristic-pdf"
                    ></pdf>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex lg5 md5 sm12 xs12>
                    <v-btn :depressed="true" color="warning" small @click="page = page +=- 1" block v-if="currentPage >= 2" class="futuristic-btn">Back</v-btn>
                  </v-flex>
                  <v-flex lg2 md2 sm12 xs12 class="text-xs-center">
                    <v-chip class="page-counter">{{currentPage}} / {{pageCount}}</v-chip>
                  </v-flex>
                  <v-flex lg5 md5 sm12 xs12>
                    <v-btn :depressed="true" color="primary" small @click="page = page + 1" block v-if="currentPage < pageCount" class="futuristic-btn">Next</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab-item key="enteredcontent">
            <v-card flat>
              <v-container class="content-container">
                <span v-html="singleProgram.desc"></span>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab-item key="contactcontent">
            <volunteer-program-settings/>
          </v-tab-item>

          <v-tab-item key="applicants">
            <v-card flat>
              <v-card-title class="search-container">
                <h3 class="earth-color">All {{singleProgram.name}} Applicants</h3>
                <v-spacer></v-spacer>
                <v-text-field
                  append-icon="search"
                  placeholder="Search"
                  single-line
                  hide-details
                  v-model="search"
                  class="futuristic-search"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="columns"
                :items="programVolunteers"
                :search="search"
                :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
                :disable-initial-sort="true"
                class="futuristic-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="font-weight-medium">{{props.item.title}} {{props.item.full_name}}</td>
                  <td>{{props.item.email}}</td>
                  <td>{{props.item.tel}}</td>
                  <td>
                    <v-chip small :color="props.item.payment_status === 'Pending payment' ? 'warning' : 'success'" dark>
                      {{props.item.payment_status}}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn :depressed="true" color="info" small @click="openApplication(props.item.volunteer_id)" class="futuristic-btn mb-1">View Applicant</v-btn>
                    <v-btn :depressed="true" color="warning" small @click="sendPaymentReminder(props.item)" v-if="props.item.payment_status === 'Pending payment'" class="futuristic-btn">Send Reminder</v-btn>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="#f44336" icon="warning" class="futuristic-alert">
                  Your search for "{{ search }}" found no results.
                </v-alert>
                <template slot="no-data">
                  <div class="text-xs-center py-4">
                    No applicants found
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import DateMixin from '../../../mixins/Functions/DateMixins'
  import ProgramVuex from '../../../mixins/Computed/Volunteer/ProgramsVuex'
  import ProgramImages from './ProgramImages'
  import pdf from 'vue-pdf'
  import VolunteerProgramSettings from './VolunteerProgramSettings'
  export default {
    components: { VolunteerProgramSettings, ProgramImages, pdf },
    name: 'volunteer-program',
    data () {
      return {
        active: '',
        type: 1,
        currentPage: 0,
        pageCount: 0,
        page: 1,
        numPages: undefined,
        delete_count: 3,
        search: '',
        columns: [
          {
            text: 'Name',
            value: 'full_name',
            class: 'table-header'
          },
          {
            text: 'Email',
            value: 'email',
            class: 'table-header'
          },
          {
            text: 'Telephone Number',
            value: 'tel',
            class: 'table-header'
          },
          {
            text: 'Payment Status',
            value: 'payment_status',
            class: 'table-header'
          },
          {
            text: 'Action',
            value: '',
            class: 'table-header',
            sortable: false
          }
        ]
      }
    },
    methods: {
      sendPaymentReminder (volunteer) {
        this.$store.dispatch('remind_volunteer_of_payment', volunteer)
      },
      openApplication (publicId) {
        this.$router.push({
          name: 'SingleVolunteerApplicant',
          params: {
            applicant_id: publicId
          }
        })
      },
      deleteProgram: function () {
        if (this.delete_count > 0) {
          this.delete_count = this.delete_count - 1
        } else {
          var data = {
            session_id: localStorage.getItem('lkjhgfdsa'),
            public_id: this.$route.params.program_id
          }
          this.$store.dispatch('delete_program', data)
        }
      }
    },
    created () {
      this.$store.dispatch('get_program', this.$route.params.program_id)
      this.$store.dispatch('get_program_volunteers', this.$route.params.program_id)
    },
    mixins: [ProgramVuex, DateMixin]
  }
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.program-title {
  font-size: 1.5rem;
  margin-bottom: 16px;
}

.program-details p {
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.futuristic-btn {
  border-radius: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-weight: 500;
  text-transform: none;
  margin-left: 8px;
}

.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-tabs >>> .v-tabs__item {
  color: #587e27;
  font-weight: 500;
}

.futuristic-tabs >>> .v-tabs__item--active {
  color: #587e27;
  font-weight: 600;
}

.futuristic-pdf {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.page-counter {
  background: #587e27 !important;
  color: white !important;
}

.content-container {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
}

.search-container {
  padding: 16px;
  background: #f9f9f9;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 0 12px;
  margin-bottom: 0;
}

.futuristic-search >>> .v-input__icon .v-icon {
  color: #587e27;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .program-title {
    font-size: 1.3rem;
  }
  
  .futuristic-btn {
    margin-bottom: 8px;
  }
  
  .futuristic-table >>> table {
    display: block;
    overflow-x: auto;
  }
}
</style>